import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DynamicComponent, slideInFromLeft, slideInFromRight } from '@ed-clients/shared';

import {HomeDynamic} from '../home.interface';

@Component({
  selector: 'dwg-home-dynamic-component',
  templateUrl: './home-dynamic-component.component.html',
  styleUrls: ['./home-dynamic-component.component.scss'],
  animations: [
    slideInFromRight(),
    slideInFromLeft()
  ],
})

// Note: Animation is disabled, see template

// void state isnt custom state.
// The void state represents the state of an element which is not a part of the DOM.
// This state occurs when an element is created but not yet placed in the DOM or the element is removed from the DOM.
// This state is useful when we want to create animations while adding or removing an element from our DOM.

export class HomeDynamicComponent implements DynamicComponent<HomeDynamic> {
  @Input() data: HomeDynamic;
  @Input() visibility = 'visible';
  @Input() slideForward = true; // initially slide from right
  @Output() animationEnd = new EventEmitter();

  animationDone(e) {
    console.log(e);
    if ( e.toState.includes('hidden') ) {
      this.animationEnd.emit(true);
    }
  }
}
